<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="login-field" v-checkenter="login" type="text" v-model="username" :placeholder="placeholder ? placeholder : 'E-mail'">
        </div>
        <button class="login-button" @click.prevent="login"><p v-html="cta"></p></button>
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    export default {
        name: 'ForgotPassword',

        props: {
            placeholder: null,
            cta: ''
        },

        data ()
        {
            return {
                username: '',
                password: ''
            }
        },

        methods: {
            login ()
            {
                this.username = this.username.toLowerCase().trim();
                
                if (this.username)
                {
                    api
                    .post(`event/${this.$store.state.eventId}/forgetPassword`, { email: this.username })
                        .then(response => {
                            this.$emit('sent', true);
                        })
                        .catch(err => {
                            this.$emit('sent', false);
                        });
                }
                else
                {
                    // show error
                    this.$emit('error', 'fail');
                }
            }
        },

        mounted ()
        {
            console.log('email mounted');
        }
        
    }
</script>

<style lang="scss">
    
</style>